import { pathSubscription } from 'nike-re-framejs';

export const route$ = pathSubscription(['route']);
